import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {AlertService} from '../../../services/notify/alert.service';
import {HelpersService} from '../../../services/helpers.service';
import {DocumentsServiceService} from '../../../controllers/documents/documents-service.service';
import {DocumentsApiService} from '../../../services/api/documents-api.service';
import {MemberModel} from '../../../models/user.model';
import {MemberService} from '../../../services/member.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalService} from '../../../services/modal/modal.service';
import {DocumentHelpersService} from '../../../services/helpers/document-helpers.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-component-button-create-fcfv',
    templateUrl: './button-create-fcfv.component.html',
    styleUrls: ['./button-create-fcfv.component.scss']
})
export class ButtonCreateFcfvComponent implements OnInit {
    @Input() public isCreateFolder: boolean;
    @Input() public isCreateCollection: boolean;
    @Output() public emitOnCreate: EventEmitter<boolean> = new EventEmitter<boolean>();
    selectedMember: MemberModel = null;
    public profile: MemberModel;
    public allMembers: MemberModel[] = [];
    public signers: any = [];
    public members: any = [];

    isLockButton = false;

    @Input() isCollection = false;
    isChecked = true;

    constructor(
        public controller: DocumentsServiceService,
        protected docApi: DocumentsApiService,
        protected alertService: AlertService,
        public helper: HelpersService,
        protected documentHelper: DocumentHelpersService,
        protected memberService: MemberService,
        protected modalService: ModalService,
        private translate: TranslateService
    ) {
        this.memberService.getCurrentMember().then(data => {
            this.profile = data;
        });
    }

    ngOnInit(): void {
    }

    onOpenModal(content: TemplateRef<any>): void {
        this.modalService.openTemplateModal(content);
    }

    onOpenUploadModal(content: TemplateRef<any>): void {
        this.signers = [];
        this.members = [];
        this.onOpenModal(content);
        this.memberService.getAllMembers().then((result: any) => {
            this.allMembers = result;
        });
    }

    onCreateFolder(folderName: HTMLInputElement, folderDescription: HTMLInputElement, modal: NgbModalRef): void {
        if (!folderName.value) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_FOLDER_NAME'), 'blue');
        }
        this.isLockButton = true;
        const data = {
            name: folderName.value,
            folder_description: folderDescription.value,
            pid: this.controller.request.id
        };

        if (data.pid === 0) {
            data.pid = null;
        }

        this.docApi.createFolder(data).subscribe({
            next: () => {
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                this.controller.loadNav();
                this.isLockButton = false;
                modal.close();
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
                this.isLockButton = false;
            }
        });
    }

    onCreateCollectionOrFile(
        file: HTMLInputElement,
        fileDescription: HTMLTextAreaElement,
        collectionDescription: HTMLTextAreaElement,
        modal: NgbModalRef
    ): void {
        if (!file.files.length) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.FILE_NOT_SELECTED'), 'blue');
        }
        this.isLockButton = true;
        const formFileCreation = ({
            document: Object.values(file.files),
            file_description: fileDescription.value,
            collection_description: collectionDescription.value,
            id: this.controller.request.id,
            signers: this.members.length ? this.members : [this.profile.guid],
            is_crypto: false,
            one_collection: this.isCollection ? false : this.isChecked,
        });

        formFileCreation.document = formFileCreation.document.filter((x: File) => {
            const name = x.name.split('.');
            if (!['docx', 'doc', 'pdf', 'docm', 'xls', 'xlsx', 'odt', 'csv'].includes(name.reverse()[0])) {
                return this.alertService.setAlert(this.translate.instant('ALERTS.FORMAT_ERROR', {name: x.name}), 'blue');
            } else {
                return x;
            }
        });

        if (!formFileCreation.document.length) {
            this.isLockButton = false;
            return this.alertService.setAlert(this.translate.instant('ALERTS.UPLOAD_FILE'), 'blue');
        }

        const directory: 'folder' | 'collection' = this.controller.request.filter === 'all' ?
            'folder' : 'collection';

        this.documentHelper.uploadFile(directory, this.controller.request.id, formFileCreation).subscribe({
            next: res => {
                this.isLockButton = false;
                this.isChecked = true;
                this.selectedMember = null;
                modal.close();
                this.documentHelper.setFileToQueue(res);
            }, error: error => {
                this.isLockButton = false;
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }

    signatories(): void {
        if (this.selectedMember) {
            this.signers.push(this.selectedMember);
            this.members.push(this.selectedMember.guid);
            this.allMembers = this.allMembers.filter(x => (x !== this.selectedMember));
        }
    }

    removeSigner(item: MemberModel): void {
        this.signers = this.signers.filter((x: MemberModel) => x !== item);
        this.members = this.members.filter((x: string) => x !== item.guid);
        this.allMembers.unshift(item);
        this.selectedMember = null;
    }
}
